import { SigninForm } from "../features/auth/components/SigninForm";

export const SigninPage = () => {
    return (
        <div className="px-6 pt-6">
            <SigninForm />
        </div>
    );
};
